import React from 'react'
import { SET_GLOBAL } from '../actionTypes'
import { IStoreState } from '../types'

interface IAction {
  type: string
  payload: IStoreState['global']
}

const initialState: IStoreState['global'] = {
  isLoading: true,
  // eslint-disable-next-line
  version: require('../../../../package.json').version,
  env: process.env.REACT_APP_ENV,
  pendingOrders: [],
}

export const globalReducer: React.Reducer<IStoreState['global'], IAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SET_GLOBAL:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
